import { GenericClassTranslate } from './genericClass';

export class PendingSignType extends GenericClassTranslate {
}

export enum PendingSignTypeEnum {
    REVIEW = 1,
    APPROVED = 2,
    GENERATE=3
}
